import { useQuery } from '@apollo/client';
import { GET_CRA_DAYS_MANUAL_EDIT_HISTORY } from '@bloomays-lib/adapter.api-bloomer';
import { CraDaysManualEditEntry } from '@bloomays-lib/types.shared';

type CraDaysManualEditHistoryResult = {
  craDaysManualEditHistory: CraDaysManualEditEntry[];
};

type UseCraDaysManualEditHistoryParams = {
  craAirtableId?: string | null;
  enabled?: boolean;
};

export const useCraDaysManualEditHistory = ({ craAirtableId, enabled = false }: UseCraDaysManualEditHistoryParams) => {
  const shouldFetch = enabled && !!craAirtableId;
  const { data, loading, error } = useQuery<CraDaysManualEditHistoryResult, { craAirtableId: string }>(
    GET_CRA_DAYS_MANUAL_EDIT_HISTORY,
    {
      variables: { craAirtableId: craAirtableId ?? '' },
      skip: !shouldFetch,
      context: { clientName: 'api.bloomers' },
      fetchPolicy: 'cache-first',
    },
  );

  return {
    entries: data?.craDaysManualEditHistory ?? [],
    loading: shouldFetch && loading,
    error,
  };
};
